/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState, useRef } from 'react';
import { IInput } from '../../../components/Common/iComponents/iInput/iInput';
import IButton from '../../../components/Common/iComponents/iButton/IButton';
import PropTypes from 'prop-types';
import Swal from "sweetalert2";
import * as url from '../../../helpers/url_helper';

import { useDispatch, useSelector } from 'react-redux';
import { sendTestEmail } from '../../../store/actions';


const OauthGoogle = ({ onUpdateClient, form, setForm }: any) => {
    const dispatch = useDispatch();
    const path = url.API_URL;
    const tabs = [
        {
            icon: "bx bxl-google",
        },
        {
            icon: "bx bxs-envelope",
            name: "Test Email",
            description: "Send a test email for the process to be successful"
        }
    ]

    const testEmailRedux = useSelector((state: any) => state.clients?.brandCustom?.email);
    const { isLoading, errorTestEmail, messageTestEmail } = useSelector((state: any) => state.clients);

    const [isTestEmail, setIsTestEmail] = useState(false)
    const [testEmail, setTestEmail] = useState("");
    const [state, setState] = useState<any>({
        activeTabProgress: 0,
        progressValue: 100 / tabs.length * 1,
        milestoneEventSH: [],
        selectedEvents: []
    });

    useEffect(() => {
        if (form.clientGoogleId && form.clientGoogleSecret && form.refreshTokenGoogle) {
            setState({
                ...state,
                activeTabProgress: 0,
                progressValue: 100 / tabs.length * (0 + 1),
            });
        }
    }, [form]);

    useEffect(() => {
        setTestEmail(testEmailRedux)
    }, [testEmailRedux]);
    useEffect(() => {
        const handleTokenMessage = (event: any) => {
            const baseUrl = `${window.location.origin}`;
            if (event.origin !== baseUrl) return;
            const { token, name: nameUserGoogle, picture: photoUserGoogle, email: smtpEmail } = event.data;
            if (token) {
                const newObject = { ...form, refreshTokenGoogle: token, nameUserGoogle, photoUserGoogle, smtpEmail }
                setState({
                    ...state,
                    activeTabProgress: 2,
                    progressValue: 100 / tabs.length * (2 + 1)
                });
                setForm(newObject)
                onUpdateClient(newObject)
            }
        };
        window.addEventListener("message", handleTokenMessage);
        return () => {
            window.removeEventListener("message", handleTokenMessage);
        };
    }, [form]);
    useEffect(() => {
        if (errorTestEmail && messageTestEmail && isTestEmail) {

            Swal.fire({
                icon: errorTestEmail ? "success" : 'error',
                title: 'Send test Email',
                text: messageTestEmail,
                showConfirmButton: true,
            })
            setIsTestEmail(false)
        }
    }, [isLoading]);

    const openPopup = () => {
        const width = 600
        const height = 800

        const screenX = window.screenX !== undefined ? window.screenX : window.screenLeft;
        const screenY = window.screenY !== undefined ? window.screenY : window.screenTop;
        const outerWidth = window.outerWidth !== undefined ? window.outerWidth : document.documentElement.clientWidth;
        const outerHeight = window.outerHeight !== undefined ? window.outerHeight : document.documentElement.clientHeight;

        const left = Math.floor((outerWidth - width) / 2) + screenX;
        const top = Math.floor((outerHeight - height) / 2) + screenY;


        const baseUrl = `${window.location.origin}`;
        const stateData = {
            url: baseUrl + "/OauthCallBack",
            clientGoogleId: form.clientGoogleId,
            clientGoogleSecret: form.clientGoogleSecret,
        }
        const stateBase64 = JSON.stringify(stateData);
        const encodedState = btoa(stateBase64);

        const scopes = [
            'https://www.googleapis.com/auth/userinfo.email',
            'https://www.googleapis.com/auth/userinfo.profile',
            'https://mail.google.com/'
        ];

        const oauth2Client = {
            url: "https://accounts.google.com/o/oauth2/v2/auth?",
            access_type: "access_type=offline",
            scope: `&scope=${encodeURIComponent(scopes.join(' '))}`,
            prompt: "&prompt=consent",
            state: "&state=" + encodedState,
            response_type: "&response_type=code",
            client_id: "&client_id=" + form.clientGoogleId,
            redirect_uri: "&redirect_uri=" + (path.endsWith('api') ? path.slice(0, -3) : path) + "oauth2callback"
        }

        const popup = window.open(
            `${oauth2Client.url + oauth2Client.access_type + oauth2Client.scope + oauth2Client.prompt + oauth2Client.state + oauth2Client.response_type + oauth2Client.client_id + oauth2Client.redirect_uri}`,
            "popupWindow",
            `width=${width},height=${height},left=${left},top=${top},scrollbars=yes`
        );
        return popup;
    };
    const handleDeleteEmail = () => {
        const newObject = { ...form, refreshTokenGoogle: "", nameUserGoogle: "", photoUserGoogle: "", smtpEmail: "" }
        setForm(newObject)
        onUpdateClient(newObject)
    };

    return (
        <>
            <div style={{ width: "60%" }}>
                <div className='d-flex justify-content-center align-items-center'>
                    <div className='row cardGoogle cursor-pointer'>
                        {form.smtpEmail && form.photoUserGoogle && form.nameUserGoogle ?
                            <>
                                <div className='col-2 justify-content-center align-items-center d-flex'>
                                    <img
                                        src={form.photoUserGoogle}
                                        alt="User Icon"
                                        style={{
                                            width: "40px",
                                            height: "40px",
                                            borderRadius: "50%",
                                        }}
                                    />
                                </div>
                                <div className='col-8'>
                                    <h2 className='nameGoogle'>{form.nameUserGoogle}</h2>
                                    <p className='emailGoogle'>{form.smtpEmail}</p>
                                </div>
                                <div className='col-2 justify-content-center align-items-center d-flex' >
                                    <IButton
                                        className="btn-delete"
                                        label={''}
                                        btnIcon="bx bx-x"
                                        actionOnClick={handleDeleteEmail}
                                    ></IButton>
                                </div>
                            </>
                            :
                            <div className='row justify-content-center align-items-center d-flex'
                                onClick={openPopup}
                            >

                                <div className='col-2 justify-content-center align-items-center d-flex'>
                                    <i className='bx bxl-google fs-1' ></i>
                                </div>
                                <div className='col-8'>
                                    <h2 className='nameGoogle'>Login with Google</h2>
                                </div>

                            </div>
                        }
                    </div>
                </div>

                <div className={`user-card ${form.smtpEmail && form.photoUserGoogle && form.nameUserGoogle ? "fade-in" : "fade-out"}`}>
                    <div className='row  ps-5'>
                        <div className='col-9'>
                            <IInput
                                title={"Email address for sending the test"}
                                value={testEmail}
                                type={'text'}
                                onInputHandler={(e:any) => setTestEmail(e.target.value)}
                            />
                        </div>
                        <div className='col-3'>
                            <IButton
                                className="btn-base m-2"
                                label={'Send Email'}
                                btnIcon="bx bx-send"
                                actionOnClick={() => {
                                    setIsTestEmail(true)
                                    dispatch(sendTestEmail(testEmail))
                                }}
                            ></IButton>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
};


OauthGoogle.propTypes = {
    onUpdateClient: PropTypes.func,
    form: PropTypes.object,
    onChangeHandler: PropTypes.func,
    setForm: PropTypes.func
};
export default OauthGoogle;
